// Fit-feedback options (optional per product). Values match the backend:
// 'short' | 'perfect' | 'long'.
export const FIT_OPTIONS = [
  { value: 'short', label: 'A little short, but okay' },
  { value: 'perfect', label: 'Perfect fit' },
  { value: 'long', label: 'A little long, but okay' },
];

// Label shown as a badge on the product card — same wording as the options.
export const FIT_BADGE = {
  short: 'a little short, but okay',
  perfect: 'perfect fit',
  long: 'a little long, but okay',
};
